import * as React from "react";
import {ComponentSpinner} from "./ComponentSpinner";


interface State {
    title?: string;
    collapsed?: boolean;
}

export class Collapsible extends React.Component<{ title: string, collapsed: boolean }, State> {

    constructor(props) {
        super(props);
        console.log("Props: ", props);
        this.state = {collapsed: this.props.collapsed};
    }

    toggleCollapsed() {
        console.log("Before toogle - Collapsed: " + this.state.collapsed);
        this.setState({collapsed: !this.state.collapsed});
        console.log("After toogle - Collapsed: " + this.state.collapsed);
    }

    getContent() {
        if (this.state.collapsed) {
            return <div></div>
        } else {
            return (
                <div className="ibox-content">
                    {this.props.children}
                </div>
            )
        }
    }

    getIcon() {
        if (this.state.collapsed) {
            return "right"
        } else {
            return "down"
        }
    }

    render() {
        return (
            <div className="ibox float-e-margins">
                <div className="ibox-title">
                    <h2 className="pointer" onClick={this.toggleCollapsed.bind(this)}><i
                        className={"fa fa-chevron-" + this.getIcon()}></i> {this.props.title}</h2>
                </div>
                {this.getContent()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/util/Collapsible.tsx